module.exports = {"title":"Définissez vos objectifs"};